import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
export class ShoppingCartService extends BaseProvider {
    constructor(globals, http) {
        super();
        this.globals = globals;
        this.http = http;
        this.paymentCompleted = false;
        this.baseUrl = "shoppingCart";
    }
    getList() {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/list`;
            this.http.get(url)
                .subscribe((data) => {
                resolve(data);
                this.shoppingCartList = data.Data;
                this.qtyProducts = this.shoppingCartList.length;
            }, (err) => { reject(err); });
        });
    }
    addToCart(userProcessId) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/${userProcessId}`;
            this.http.post(url, {})
                .subscribe((data) => {
                resolve(data);
                this.qtyProducts = this.shoppingCartList.length;
            }, (err) => { reject(err); });
        });
    }
    removeFromCart(userProcessId) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/${userProcessId}`;
            this.http.delete(url)
                .subscribe((data) => {
                resolve(data);
                this.qtyProducts = this.shoppingCartList.length;
            }, (err) => { reject(err); });
        });
    }
    payAll(data) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/payment`;
            this.http.post(url, data)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    getListByAuthNumber(authNumber) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/invoiceDetail/${authNumber}`;
            this.http.get(url)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    updatePaymentStatus(processCart) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/updatePaymentStatus`;
            this.http.put(url, processCart)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    deleteSelection(selection) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/deleteSelectedUserProcess`;
            this.http.post(url, selection)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    initPaymentPlan(cardInfo) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/init`;
            this.http.post(url, cardInfo)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    paySelection(installment) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/pay`;
            this.http.post(url, installment)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    getPaymentPlanInvoice() {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/invoicePaymentPlanInfo`;
            this.http.get(url)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
}
ShoppingCartService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ShoppingCartService_Factory() { return new ShoppingCartService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient)); }, token: ShoppingCartService, providedIn: "root" });
